import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from './authConfig';
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const nonce = document
  .querySelector('meta[name="csp-nonce"]')
  ?.getAttribute("content");

console.log("Emotion Nonce:", nonce);

const emotionCache = createCache({
  key: "css",
  nonce,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CacheProvider value={emotionCache}>
    <BrowserRouter>
      <App instance={msalInstance} />
    </BrowserRouter>
  </CacheProvider>
);


